/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Fri Jul 29 2022
*  File : ModuleLoader.ts
*******************************************/



import { ClientSdkCorePublic } from "@api-commons/sdk/ClientSdkPublicInterface.js";
import { PushServiceInterface } from "@api-commons/subscriptions/PushServiceInterface.js";
import { GuiController } from "@personal-area/gui/GuiController.js";

import { AbstractModuleLoader } from '@personal-area/modularization/AbstractModuleLoader.js';

import { FanpageGuiController } from "../gui/FanpageGuiController.js";
import { CatalogueLanguages } from "@ciaopeople/cp-shatsu/Catalogue";


export class FanpageModuleLoader extends AbstractModuleLoader {
    
    public getGui(): Promise<FanpageGuiController> {
        return super.getGui().then(
            g => g as FanpageGuiController
        );
    }

    protected initSdkClient(): Promise<ClientSdkCorePublic> {
        return import(/* webpackChunkName: "fanpage/it/pa/sdk-client" */ "./modules/ClientLightweight.js").then(
            ({ SdkClient }) => {
                return SdkClient(this.configHelper.getOriginal(), this);
            }
             
        );
    }

    protected initSdkServer(): Promise<any> {
        return this.injectScript(this.configHelper.getSdkJsServerUrl(), "fp-sdk-server");
    }

    protected initPushHelper(): Promise<PushServiceInterface> {
        return this.getSdkClient().then(
            (sdk) => {
                return sdk.pushNotificationService;
            }
        );
    }


    protected initGui(): Promise<GuiController> {
      
        return this.getSdkClient().then(
            sdk => {
                const gui = import(/* webpackChunkName: "fanpage/it/pa/gui" */ './modules/GUI.js');
                
                return gui.then(
                    ({ GUI }) => {
                        return GUI(
                            this.win,
                            sdk,
                            CatalogueLanguages.it
                        );
                    }
                );

            }
        );
    }


}